import React, { useEffect,Suspense } from 'react'
//import Faq from '../components/faqs/Faqs';
const Faq = React.lazy(() => import('../components/faqs/Faqs'));
import { useAppContext } from "../Context/Store"; 

export default function Faqs({ sendBodyClass }) {

  const { isError, isLoading, FaqsData } = useAppContext();

  if(isError){
    //console.log("Home Page Component", contextData); 
    return <div>Error Term and Condition Page...</div>;  // Handle Error state
  }

  if (!FaqsData || isLoading) {
    return <div>Loading...</div>;  // Handle loading state
  }
  
  const { properties } = FaqsData;
  useEffect(() => {
    sendBodyClass(false); 
  }, []);
  return (
    <>
    <Suspense fallback={<div>Loading...</div>}>
      <Faq FaqsData={properties?.descriptionText || " "} />
      </Suspense>
    </>
  )
}
